







import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class ListItemClickIndicator extends Vue {
    @Prop({ type: String, default: null }) readonly clickIcon!: string
}
